<sc-error-page statusCode="500"
               i18n-statusCode
               title="Error Occurred."
               i18n-title
               message="Please try again later"
               i18n-message>
</sc-error-page>